import { useContext } from "react";

import { FilterButtonContext } from "../context/FilterButtonContext";

export function useFilterButtonContext() {
  const context = useContext(FilterButtonContext);
  if (context === undefined) {
    throw new Error("useFilterButtonContext must be used within a FilterButtonProvider");
  }
  return context;
}
